




















import traceQuery from '~/queries/trace.gql'

export default

	props:
		traceData: Object

	data: ->
		loaded: false
		rows: []
		sectionData: {}

		tableHeading: [
			{
				title: 'Measure'
			},
			{
				title: 'Oil Result'
			},
			{
				title: 'Industry Standard'
				subtitle: '(OOCC)*'
			}
		]

		tableCaption: "*OOCC stands for the Olive Oil Commission of California"


	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'testResults'
				slug: 'my-oils-test-results'

		@loaded = true

		@$nextTick =>
			@createRows()

	computed:
		date: -> "Date of testing: #{@traceData?.DateTest}"
		tableData: -> @rows.filter (row) ->
			!row?.cell1?.includes 'UV'

		filteredTableData: -> @tableData.filter (row) ->
			!row?.cell1?.includes 'Peroxide'

	methods:
		createRows: ->
			for item in @traceData?.TestResults
				result = item.TestResult
				if !isNaN(parseFloat(item.TestResult))
					result = parseFloat(item.TestResult).toFixed(1)
				@rows.push {
					cell1: item.TypeDesc
					cell2: result
					cell3: item.IndustryStandard
				}


